var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _circle2, _circle3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorsSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.171 33.1523C110.171 33.4285 110.395 33.6523 110.671 33.6523C110.947 33.6523 111.171 33.4285 111.171 33.1523L110.171 33.1523ZM111.171 29.9503C111.171 29.6741 110.947 29.4503 110.671 29.4503C110.395 29.4503 110.171 29.6741 110.171 29.9503L111.171 29.9503ZM110.171 23.5462C110.171 23.8223 110.395 24.0462 110.671 24.0462C110.947 24.0462 111.171 23.8223 111.171 23.5462L110.171 23.5462ZM111.171 17.1421C111.171 16.8659 110.947 16.6421 110.671 16.6421C110.395 16.6421 110.171 16.8659 110.171 17.1421L111.171 17.1421ZM110.171 10.738C110.171 11.0141 110.395 11.238 110.671 11.238C110.947 11.238 111.171 11.0141 111.171 10.738L110.171 10.738ZM111.171 33.1523L111.171 29.9503L110.171 29.9503L110.171 33.1523L111.171 33.1523ZM111.171 23.5462L111.171 17.1421L110.171 17.1421L110.171 23.5462L111.171 23.5462ZM111.171 10.738L111.171 7.53591L110.171 7.53591L110.171 10.738L111.171 10.738Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.951 26.5973L174.135 63.289L152.951 99.9806L110.583 99.9806L89.3993 63.289L110.583 26.5973L152.951 26.5973Z",
    fill: "#FBF6FF",
    stroke: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.6426 68.0843L93.7921 87.3957L82.6426 106.707L60.3438 106.707L49.1943 87.3957L60.3438 68.0843L82.6426 68.0843Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.6426 21.3734L93.7921 40.6848L82.6426 59.9962L60.3438 59.9962L49.1943 40.6848L60.3438 21.3734L82.6426 21.3734Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.643 4.04526L203.792 23.3566L192.643 42.668L170.344 42.668L159.194 23.3566L170.344 4.04526L192.643 4.04526Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.049 37.2257L224.96 47.4649L219.049 57.7042L207.225 57.7042L201.314 47.4649L207.225 37.2257L219.049 37.2257Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.2815 9.35069L56.1932 19.5899L50.2815 29.8292L38.4583 29.8292L32.5466 19.5899L38.4583 9.35069L50.2815 9.35069Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.734 62.8429L210.645 73.0821L204.734 83.3214L192.91 83.3214L186.999 73.0821L192.91 62.8429L204.734 62.8429Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.747 1.81554L158.659 12.0548L152.747 22.294L140.924 22.294L135.012 12.0548L140.924 1.81554L152.747 1.81554Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.123 63.4492V81.1917C128.123 82.8961 128.754 85.4271 131.864 85.4271C134.974 85.4271 135.767 82.8961 135.767 81.1917V69.8984C135.767 68.8634 136.292 66.7932 138.394 66.7932C140.496 66.7932 141.525 66.7932 142.082 66.7932",
    stroke: "#FF8165",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.245 55C121.85 59.0364 124.628 62.3204 128.869 62.3204C132.06 62.3204 134.729 59.3185 135.634 55",
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.703 63.4492V81.1917C128.703 82.8961 129.333 85.4271 132.443 85.4271C135.553 85.4271 136.346 82.8961 136.346 81.1917V69.8984C136.346 68.8634 136.871 66.7932 138.973 66.7932C141.075 66.7932 142.104 66.7932 142.661 66.7932",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.821 45.3125V55.1057C120.9 57.8128 122.54 63.2269 128.464 63.2269C134.388 63.2269 136.028 57.8128 136.108 55.1057V45.3125",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 53C121.697 54.7516 124.452 58.2549 128.465 58.2549C132.478 58.2549 135.233 54.7516 136.109 53",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.821,
    cy: 43.1497,
    r: 2.89973,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.108 46.0495C137.71 46.0495 139.008 44.7512 139.008 43.1497C139.008 41.5483 137.71 40.25 136.108 40.25C134.507 40.25 133.208 41.5483 133.208 43.1497C133.208 44.7512 134.507 46.0495 136.108 46.0495Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.216,
    cy: 66.773,
    r: 3.08755,
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.236,
    cy: 66.746,
    r: 2.01942,
    fill: "#A020FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8882 93.8477L70.022 93.8477",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6007 81.5586H75.135C78.6928 81.5586 79.0486 83.2224 79.2893 85.2525L80.231 93.1006C80.5345 95.6748 79.7392 97.7782 76.0767 97.7782H66.6694C62.9964 97.7782 62.2012 95.6748 62.5151 93.1006L63.4569 85.2525C63.6871 83.2224 64.0429 81.5586 67.6007 81.5586Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1815 83.1301V79.4676C67.1815 77.898 68.2279 76.8516 69.7976 76.8516H72.9368C74.5065 76.8516 75.5529 77.898 75.5529 79.4676V83.1301",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8882 93.1445L65.9857 93.1445",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5066 87.7643C74.5066 88.0154 74.4752 88.2587 74.4124 88.4941C74.3418 88.8081 74.2162 89.1142 74.0514 89.381C73.5099 90.2914 72.5131 90.9035 71.3673 90.9035C70.5589 90.9035 69.8291 90.5974 69.2797 90.0952C69.0442 89.8911 68.8402 89.6478 68.6832 89.381C68.3928 88.9101 68.228 88.3529 68.228 87.7643C68.228 86.9167 68.5655 86.1397 69.1149 85.5746C69.6878 84.986 70.4883 84.625 71.3673 84.625C72.2934 84.625 73.1331 85.0253 73.6982 85.6688C74.2005 86.226 74.5066 86.9638 74.5066 87.7643Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5376 87.7539H70.1989",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3696 86.6055V88.9521",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9456 42.696C60.9456 39.3811 60.9456 37.7237 62.1813 36.6939C63.4171 35.6641 65.406 35.6641 69.3839 35.6641H73.6031C77.581 35.6641 79.5699 35.6641 80.8057 36.6939C82.0414 37.7237 82.0414 39.3811 82.0414 42.696C82.0414 46.0109 82.0414 47.6684 80.8057 48.6982C79.5699 49.728 77.581 49.728 73.6031 49.728H69.3839C65.406 49.728 63.4171 49.728 62.1813 48.6982C60.9456 47.6684 60.9456 46.0109 60.9456 42.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1985 35.8041C63.3756 35.7121 63.5723 35.6641 63.7719 35.6641H78.6398C78.7995 35.6641 78.9578 35.6948 79.1058 35.7546L80.6305 36.3703C81.0301 36.5318 81.3178 36.8885 81.3909 37.3133L81.5392 38.1755H60.9456L61.4325 37.0391C61.5459 36.7746 61.7475 36.5575 62.0029 36.4249L63.1985 35.8041Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9456 42.696C60.9456 39.3811 60.9456 37.7237 62.1813 36.6939C63.4171 35.6641 65.406 35.6641 69.3839 35.6641H73.6031C77.581 35.6641 79.5699 35.6641 80.8057 36.6939C82.0414 37.7237 82.0414 39.3811 82.0414 42.696C82.0414 46.0109 82.0414 47.6684 80.8057 48.6982C79.5699 49.728 77.581 49.728 73.6031 49.728H69.3839C65.406 49.728 63.4171 49.728 62.1813 48.6982C60.9456 47.6684 60.9456 46.0109 60.9456 42.696Z",
    stroke: "#081E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5105 35.6628C75.5105 33.7686 75.5105 32.8215 74.9221 32.233C74.3336 31.6445 73.3865 31.6445 71.4923 31.6445C69.598 31.6445 68.6509 31.6445 68.0625 32.233C67.474 32.8215 67.474 33.7686 67.474 35.6628",
    stroke: "#081E54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.4939,
    cy: 43.7058,
    rx: 4.01826,
    ry: 4.01826,
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5039 43.7044H69.4856M71.4947 41.6953V45.7136",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.025 13.0604L181.997 13.1257L179.346 19.3976L177.011 19.2966C176.454 19.2726 175.916 19.3821 175.423 19.598L177.027 15.7007L177.064 15.6074L177.128 15.4583C177.147 15.4022 177.166 15.3461 177.192 15.2998C178.39 12.4762 179.63 11.875 182.025 13.0604Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.958 12.9503L182.928 13.019L180.08 19.6285H177.281C176.613 19.6285 175.975 19.766 175.396 20.0115L177.114 15.9064L177.154 15.8081L177.222 15.651C177.242 15.5921 177.262 15.5332 177.291 15.4841C178.578 12.5083 180.031 11.8307 182.958 12.9503Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.252 19.8239C187.81 19.6864 187.339 19.6274 186.867 19.6274H180.081L182.929 13.018L182.958 12.9492C183.106 12.9983 183.243 13.0671 183.391 13.126L185.561 14.0393C186.769 14.5402 187.614 15.0607 188.124 15.6893C188.222 15.8071 188.301 15.9151 188.37 16.0428C188.458 16.1803 188.527 16.3178 188.566 16.4651C188.605 16.5535 188.635 16.6419 188.655 16.7205C188.92 17.5454 188.763 18.557 188.252 19.8239Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66 24.4215V26.3366C191.66 26.533 191.65 26.7294 191.64 26.9258C191.454 30.3533 189.539 32.0818 185.905 32.0818H178.245C178.009 32.0818 177.773 32.0622 177.547 32.0327C174.424 31.8265 172.755 30.1569 172.549 27.0339C172.519 26.808 172.499 26.5723 172.499 26.3366V24.4215C172.499 22.4475 173.698 20.7485 175.406 20.0119C175.996 19.7664 176.624 19.6289 177.292 19.6289H186.877C187.358 19.6289 187.83 19.6977 188.262 19.8253C190.216 20.4244 191.66 22.2511 191.66 24.4215Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.642 25.9883V26.8427C183.642 27.5667 182.968 28.1517 182.139 28.1517C181.31 28.1517 180.632 27.5667 180.632 26.8427V25.9883C180.632 26.7122 181.306 27.2257 182.139 27.2257C182.968 27.2257 183.642 26.708 183.642 25.9883Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.641 24.8282C183.641 25.0387 183.582 25.2323 183.481 25.4006C183.233 25.8089 182.723 26.0656 182.134 26.0656C181.545 26.0656 181.035 25.8047 180.787 25.4006C180.686 25.2323 180.627 25.0387 180.627 24.8282C180.627 24.4662 180.796 24.1421 181.065 23.9064C181.339 23.6665 181.713 23.5234 182.13 23.5234C182.546 23.5234 182.921 23.6707 183.195 23.9064C183.472 24.1379 183.641 24.4662 183.641 24.8282Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.642 24.8285V25.986C183.642 26.7099 182.968 27.2234 182.139 27.2234C181.31 27.2234 180.632 26.7057 180.632 25.986V24.8285C180.632 24.1046 181.306 23.5195 182.139 23.5195C182.556 23.5195 182.93 23.6668 183.204 23.9025C183.473 24.1382 183.642 24.4665 183.642 24.8285Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.115 15.9023L175.396 20.0075C173.688 20.7441 172.489 22.4431 172.489 24.4171V21.5395C172.489 18.7504 174.473 16.4229 177.115 15.9023Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.659 21.5423V24.4198C191.659 22.2592 190.225 20.4227 188.261 19.8334C188.771 18.5567 188.919 17.555 188.673 16.7202C188.653 16.6318 188.624 16.5434 188.585 16.4648C190.411 17.4077 191.659 19.3424 191.659 21.5423Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.522 30.6826C178.522 30.9856 178.484 31.2792 178.408 31.5633C178.323 31.9421 178.171 32.3115 177.972 32.6335C177.319 33.732 176.116 34.4707 174.733 34.4707C173.758 34.4707 172.877 34.1013 172.214 33.4952C171.93 33.249 171.684 32.9554 171.495 32.6335C171.144 32.0652 170.945 31.3929 170.945 30.6826C170.945 29.6598 171.353 28.7223 172.016 28.0404C172.707 27.3302 173.673 26.8945 174.733 26.8945C175.851 26.8945 176.864 27.3775 177.546 28.1541C178.152 28.8265 178.522 29.7166 178.522 30.6826Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.145 30.6641H173.323",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.734 29.2812V32.1128",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_1670_59628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.924 43.7148H211.154C209.823 43.7148 209.523 44.3802 209.358 45.2029L208.75 48.1002H217.335L216.727 45.2029C216.548 44.3802 216.255 43.7148 214.924 43.7148Z",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.919 47.207H211.149C209.818 47.207 209.089 47.5282 208.924 47.9224L208.745 48.2801H217.33L217.151 47.9224C216.972 47.5282 216.25 47.207 214.919 47.207Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.397 53.2238C218.454 53.643 217.954 54.005 217.311 54.005H216.303C215.724 54.005 215.645 53.8383 215.538 53.6382L215.431 53.4239C215.281 53.1333 215.418 52.3953 214.646 52.3953H213.036H211.605C210.833 52.3953 210.778 53.1571 210.642 53.4239L210.535 53.6382C210.435 53.843 210.356 54.005 209.77 54.005H208.762C208.119 54.005 207.612 53.643 207.676 53.2238L207.976 51.0468C208.055 50.5086 208.205 50.0703 209.613 50.0703H216.453C217.861 50.0703 218.011 50.5086 218.09 51.0468L218.397 53.2238Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.394 52.8297C218.451 53.4592 217.951 54.0029 217.307 54.0029H216.298C215.719 54.0029 215.64 53.7525 215.533 53.4521L215.425 53.1302C215.275 52.6938 215.175 52.3933 214.402 52.3933H211.655C210.883 52.3933 210.768 52.7295 210.632 53.1302L210.525 53.4521C210.425 53.7597 210.346 54.0029 209.759 54.0029H208.751C208.107 54.0029 207.599 53.4592 207.663 52.8297L207.964 49.5603C208.042 48.7519 208.193 48.0938 209.602 48.0938H216.448C217.858 48.0938 218.008 48.7519 218.087 49.5603L218.394 52.8297Z",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.745 46.4922H208.208",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.866 46.4922H217.329",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.818 50.7852H211.427",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.646 50.7852H216.256",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.825 45.0785C218.993 44.6885 218.933 44.1605 218.621 43.6985C218.315 43.2365 217.847 42.9785 217.421 42.9845",
    stroke: "#081E54",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.691 45.6731C220.943 44.7671 220.763 43.6572 220.121 42.6972C219.479 41.7372 218.519 41.1492 217.583 41.0352",
    stroke: "#081E54",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.311,
    y: 19.9648,
    width: 3.40714,
    height: 3.12321,
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7342 12.8711H44.5532C44.8677 12.8711 45.125 13.0802 45.125 13.3357V14.9618C45.125 15.2174 44.8677 15.4265 44.5532 15.4265H39.7342C39.4198 15.4265 39.1625 15.2174 39.1625 14.9618V13.3357C39.1625 13.0802 39.4198 12.8711 39.7342 12.8711Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7896 12.9297H44.4377C44.741 12.9297 44.9891 13.1817 44.9891 13.4897V15.4498C44.9891 15.7578 44.741 16.0098 44.4377 16.0098H39.7896C39.4863 16.0098 39.2382 15.7578 39.2382 15.4498V13.4897C39.2382 13.1817 39.4863 12.9297 39.7896 12.9297Z",
    stroke: "#081E54",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3126 16.3516V16.6348C44.3126 17.6901 46.0041 17.7386 46.0041 18.6418V19.9385",
    stroke: "#081E54",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6532 25.5919H39.0247C38.5848 25.5919 38.2231 25.2188 38.2231 24.7626V18.7963C38.2231 17.8299 39.7611 17.7811 39.7611 16.6539V16.3516",
    stroke: "#081E54",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2231 19.4297H41.7063V23.1943H38.2231V19.4297Z",
    stroke: "#081E54",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8669 18.7241C44.2258 18.574 44.6207 18.7365 44.7735 19.0722L45.5529 20.7842C45.6238 20.6169 45.7605 20.4739 45.9445 20.3969C46.2715 20.2602 46.6393 20.378 46.8077 20.6585C46.8626 20.4525 47.0138 20.2699 47.2307 20.1791C47.5577 20.0426 47.9255 20.1604 48.094 20.4407C48.1488 20.2348 48.3001 20.0522 48.5172 19.9615C48.8761 19.8115 49.3033 19.9608 49.4238 20.3096L50.3101 22.8765C51.0306 24.9637 48.4582 27.1647 46.531 25.903L43.1881 23.7148C42.8754 23.5102 42.8036 23.0876 43.0285 22.7758C43.3844 22.6272 44.0884 22.6351 44.4033 22.8413L45.0364 23.2557L43.4686 19.6176C43.3227 19.2788 43.508 18.8742 43.8669 18.7241Z",
    stroke: "#081E54",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.409 72.6125C201.409 73.85 200.409 74.8562 199.171 74.8562C197.934 74.8562 196.934 73.85 196.934 72.6125C196.934 71.375 197.934 70.375 199.171 70.375C200.409 70.375 201.409 71.375 201.409 72.6125Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58 79.4561C202.092 79.5794 201.514 79.6364 200.837 79.6364H197.506C196.828 79.6364 196.251 79.5794 195.762 79.4561C195.884 78.2226 197.367 77.25 199.171 77.25C200.976 77.25 202.458 78.2226 202.58 79.4561Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.009 79.5117C202.459 79.6742 201.809 79.7492 201.046 79.7492H197.296C196.534 79.7492 195.884 79.6742 195.334 79.5117C195.471 77.8867 197.14 76.6055 199.171 76.6055C201.203 76.6055 202.871 77.8867 203.009 79.5117Z",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.046 67.25H197.296C194.171 67.25 192.921 68.5 192.921 71.625V75.375C192.921 77.7375 193.634 79.0312 195.334 79.5125C195.471 77.8875 197.14 76.6062 199.171 76.6062C201.203 76.6062 202.871 77.8875 203.009 79.5125C204.709 79.0312 205.421 77.7375 205.421 75.375V71.625C205.421 68.5 204.171 67.25 201.046 67.25ZM199.171 74.8562C197.934 74.8562 196.934 73.85 196.934 72.6125C196.934 71.375 197.934 70.375 199.171 70.375C200.409 70.375 201.409 71.375 201.409 72.6125C201.409 73.85 200.409 74.8562 199.171 74.8562Z",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.409 72.6125C201.409 73.85 200.409 74.8562 199.171 74.8562C197.934 74.8562 196.934 73.85 196.934 72.6125C196.934 71.375 197.934 70.375 199.171 70.375C200.409 70.375 201.409 71.375 201.409 72.6125Z",
    stroke: "#081E54",
    strokeWidth: 0.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.277 14.6018C150.576 13.6402 152.986 11.0628 152.986 9.30333C152.986 7.73573 151.649 6.46484 149.999 6.46484C148.891 6.46484 147.926 7.03973 147.411 7.89128C146.895 7.03973 145.93 6.46484 144.822 6.46484C143.173 6.46484 141.835 7.73573 141.835 9.30333C141.835 10.5699 143.084 12.2605 144.269 13.4668",
    fill: "#E4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.205 15.4447L141.339 14.8711L143.231 17.9374L142.07 18.6526",
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.205 15.1275L141.47 14.4961L143.58 17.8717L142.285 18.659",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.691 14.9183L148.22 14.9168C148.686 14.9168 149.063 14.5394 149.063 14.0735C149.063 13.6079 148.686 13.2305 148.22 13.2305L144.995 13.2319C144.622 13.2319 144.255 13.3311 143.933 13.5191L141.896 14.7075",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.691 14.9183L148.22 14.9168C148.686 14.9168 149.063 14.5394 149.063 14.0735C149.063 13.6079 148.686 13.2305 148.22 13.2305L144.995 13.2319C144.622 13.2319 144.255 13.3311 143.933 13.5191L141.896 14.7075",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.433 14.9127L152.12 13.2945C152.549 13.1166 153.045 13.3223 153.223 13.751C153.401 14.1799 153.195 14.6762 152.766 14.8538L149.038 16.6443C148.778 16.7545 148.498 16.8114 148.215 16.8114H144.902C144.673 16.8114 144.447 16.8737 144.251 16.9916L143.497 17.4441",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.433 14.9127L152.12 13.2945C152.549 13.1166 153.045 13.3223 153.223 13.751C153.401 14.1799 153.195 14.6762 152.766 14.8538L149.038 16.6443C148.778 16.7545 148.498 16.8114 148.215 16.8114H144.902C144.673 16.8114 144.447 16.8737 144.251 16.9916L143.497 17.4441",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.357 14.4938C150.733 13.4216 153.286 10.5481 153.286 8.58648C153.286 6.83878 151.869 5.42188 150.122 5.42188C148.948 5.42188 147.925 6.06281 147.379 7.0122C146.833 6.06281 145.81 5.42188 144.636 5.42188C142.889 5.42188 141.472 6.83878 141.472 8.58648C141.472 9.99853 142.795 11.8834 144.05 13.2283",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.452 63.7891L0.671211 63.7891",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.329 57.7617L224.438 57.7617",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.11 99.3281C151.833 99.3281 151.61 99.552 151.61 99.8281C151.61 100.104 151.833 100.328 152.11 100.328V99.3281ZM155.274 100.328C155.55 100.328 155.774 100.104 155.774 99.8281C155.774 99.552 155.55 99.3281 155.274 99.3281V100.328ZM161.603 99.3281C161.327 99.3281 161.103 99.552 161.103 99.8281C161.103 100.104 161.327 100.328 161.603 100.328V99.3281ZM167.932 100.328C168.208 100.328 168.432 100.104 168.432 99.8281C168.432 99.552 168.208 99.3281 167.932 99.3281V100.328ZM174.26 99.3281C173.984 99.3281 173.76 99.552 173.76 99.8281C173.76 100.104 173.984 100.328 174.26 100.328V99.3281ZM180.589 100.328C180.865 100.328 181.089 100.104 181.089 99.8281C181.089 99.552 180.865 99.3281 180.589 99.3281V100.328ZM186.918 99.3281C186.642 99.3281 186.418 99.552 186.418 99.8281C186.418 100.104 186.642 100.328 186.918 100.328V99.3281ZM193.247 100.328C193.523 100.328 193.747 100.104 193.747 99.8281C193.747 99.552 193.523 99.3281 193.247 99.3281V100.328ZM199.575 99.3281C199.299 99.3281 199.075 99.552 199.075 99.8281C199.075 100.104 199.299 100.328 199.575 100.328V99.3281ZM205.904 100.328C206.18 100.328 206.404 100.104 206.404 99.8281C206.404 99.552 206.18 99.3281 205.904 99.3281V100.328ZM212.233 99.3281C211.957 99.3281 211.733 99.552 211.733 99.8281C211.733 100.104 211.957 100.328 212.233 100.328V99.3281ZM152.11 100.328H155.274V99.3281H152.11V100.328ZM161.603 100.328H167.932V99.3281H161.603V100.328ZM174.26 100.328H180.589V99.3281H174.26V100.328ZM186.918 100.328H193.247V99.3281H186.918V100.328ZM199.575 100.328H205.904V99.3281H199.575V100.328ZM212.233 100.328H215.397V99.3281H212.233V100.328Z",
    fill: "#A020FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8082 63.7891H66.9726",
    stroke: "#B756FF",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_59628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(205.671 40)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsSearch);
export default __webpack_public_path__ + "static/media/DoctorsSearch.739e9fc6629c2cb93d3c99ab9cb57e7d.svg";
export { ForwardRef as ReactComponent };